import React from 'react';

import { listItemsStyles, listTextStyles, customCardStyles } from './ParentGroups.styled';
import { List, ListItem, ListItemText } from '@material-ui/core';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import { Card } from 'components/UI';

const ParentGroups = ({ parentGroups, menuOptions, handleChangePage }) => {
  const listClasses = listTextStyles();
  const cardClasses = customCardStyles();
  const listItemsClasses = listItemsStyles();

  return (
    <Card
      menuItems={menuOptions}
      headerActionType="vertical"
      title={i18n.t('user_groups.parent.parent_groups')}
      data-cy="parent-groups-widget-card"
      contentRootClasses={cardClasses}
    >
      <List>
        {parentGroups?.length
          ? parentGroups?.map((parent, index) => (
              <ListItem key={index} classes={listItemsClasses}>
                <ListItemText classes={listClasses} primary={parent?.name} />
              </ListItem>
            ))
          : i18n.t('user_groups.parent.empty_parents')}
      </List>
    </Card>
  );
};

ParentGroups.propTypes = {
  menuOptions: PropTypes.array,
  parentGroups: PropTypes.array.isRequired,
};

ParentGroups.defaultProps = {
  menuOptions: [],
  parentGroups: [],
  handleChangePage: () => {},
};

export default ParentGroups;
